import styled from 'styled-components';

import { colors, radii } from '@gbs-monorepo-packages/styles';

interface IDropzoneProps {
  isDragAccept: boolean;
  isDragReject: boolean;
  isFocused: boolean;
  isDisabled: boolean;
}

export const Container = styled.div<IDropzoneProps>`
  flex: 1;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-radius: ${radii.lg};
  border-color: ${(props: IDropzoneProps) => {
    if (props.isDisabled === true) {
      return colors.gray300;
    }
    if (props.isDragAccept === true) {
      return colors.dropzoneBorderSuccess;
    }
    if (props.isDragReject === true) {
      return colors.dropzoneBorderError;
    }
    if (props.isFocused === true) {
      return colors.dropzoneBorderFocus;
    }
    return colors.dropzoneBorder;
  }};
  border-style: dashed;
  background-color: ${colors.dropzoneBackground};
  color: ${(props: IDropzoneProps) =>
    props.isDisabled === true ? colors.gray400 : colors.dropzoneText};
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: ${(props: IDropzoneProps) =>
    props.isDisabled === true ? 'not-allowed' : 'pointer'};
  opacity: ${(props: IDropzoneProps) => (props.isDisabled === true ? 0.6 : 1)};

  &:hover,
  &:focus-within {
    ${(props: IDropzoneProps) =>
      props.isDisabled === false &&
      `
      border-color: ${colors.blue300};
      background: ${colors.backgroundHover};
      cursor: pointer;
    `}
  }
`;

export const DropzoneMessage = styled.span`
  color: ${colors.gray400};
  font-size: 1rem;
  font-weight: 500;

  span {
    color: ${colors.blue300};
    text-decoration: underline;
    font-weight: 600;
  }
`;
